import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { BUILDING_TYPE_MANSION, ITEM_MODE_NO } from '../../Constants';
import * as THREE from 'three';

/**
 * 必ず梁の自動生成後に呼び出されるウィザード
 * 
  * 下記ルールにて自動生成を行っているため、内寸吸着のオフセットが算出可能となる
  * 4点で生成。shape(dotlist) 反時計回りに作成している。shape[1], shape[2] が外周と一致。
 */
export class WizardBeamSizeSettingDialog extends Dialog {

  public itemList: marietta.webcad.item.Beam[];

  private target: marietta.webcad.item.Beam;

  private currentIndex = 0;

  constructor(draggable: boolean) {
    super(draggable);

    const id = 'WizardBeamSizeSettingDialog';
    const title = (marietta.webcad.WebCADGlobal.language === 'jp') ? '梁サイズ設定' : 'Beam Height Setting';

    let contents = '<div class="dialogBeamSetting">';
    // 数値設定
    contents += '<table id="beamSizeSettingGroup">';
    contents += '<tbody>';
    contents += '<tr>';
    contents += '<th><label for="autoBeamWidth"><span class="jp">幅</span><span class="en">Width</span></label></th>';
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      contents += '<td><input type="number" min="10" max="1000" name="autoBeamWidth" id="autoBeamWidth" value="350"><td>mm</td></td>';
    } else { // 戸建て時はドロップダウンリスト
      contents += `<td>${marietta.webcad.WebCADGlobal.webcad2Dmanager.modulePitch}mmの`;
      contents += '<select id="divisionList">';
      contents += '<option value="0.5" id="radioAutoBeamWidth1">1/2</option>';
      contents += '<option value="0.25" id="radioAutoBeamWidth2" selected>1/4</option>';
      contents += '<option value="0.125" id="radioAutoBeamWidth3">1/8</option>';
      contents += '</select>';
      contents += '<td>mm</td></td>';
    }
    contents += '</tr>';
    contents += '<tr>';
    contents += '<th><label for="autoBeamHeight"><span class="jp">高さ</span><span class="en">Height</span></label></th>';
    contents += '<td><input type="number" min="10" max="1000" name="autoBeamHeight" id="autoBeamHeight" value="500"><td>mm</td></td>';
    contents += '</tr>';
    contents += '</tbody>';
    contents += '</table>';
    contents += '<div><p id="warningMsg"></p></div>';
    contents += '</div>';

    let footer = '<button id="btnCancelBeamSizeSetting"><span class="jp">作成しない</span><span class="en">Cancel</span></button>';
    footer += '<button id="btnDoneBeamSizeSetting"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';

    this.createDialog(id, title, contents, footer);

    document.getElementById('btnDoneBeamSizeSetting').addEventListener('click', this.onBtnSizeSetClicked);
    document.getElementById('btnCancelBeamSizeSetting').addEventListener('click', this.onBtnCancelClicked);

    this.addEvevntInputCheck();

    // 梁リスト取得
    const currentFloor = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor;
    this.itemList = <marietta.webcad.item.Beam[]>marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(currentFloor, ITEM_MODE_NO.MODE_BEAM_NO).getAllChildren();

    this.next();
  }

  /**
   * 入力チェックイベント付与
   * フォーカスが外れた時
   */
  private addEvevntInputCheck() {
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      const inputWidthElement = <HTMLInputElement>document.getElementById('autoBeamWidth');
      inputWidthElement.addEventListener('blur', this.inputWidthCheck);
    }
    const inputHeightElement = <HTMLInputElement>document.getElementById('autoBeamHeight');
    inputHeightElement.addEventListener('blur', this.inputHeightCheck);
  }

  /**
   * 入力チェックイベント
   */
  private removeEvevntInputCheck() {
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      const inputWidthElement = <HTMLInputElement>document.getElementById('autoBeamWidth');
      inputWidthElement.removeEventListener('blur', this.inputWidthCheck);
    }
    const inputHeightElement = <HTMLInputElement>document.getElementById('autoBeamHeight');
    inputHeightElement.removeEventListener('blur', this.inputHeightCheck);
  }

  /**
   * 幅入力チェック
   */
  private inputWidthCheck = ()=> {
    const min = 10
    const max = 1000;

    const inputWidthElement = <HTMLInputElement>document.getElementById('autoBeamWidth');
    const floatValue = parseFloat(inputWidthElement.value);
    if (floatValue === null || Number.isNaN(floatValue)) {
      inputWidthElement.value = String(min);
    }
    // 値が最小値未満の場合、最小値に設定
    if (floatValue < min) {
      inputWidthElement.value = String(min);
    }
    // 値が最大値を超える場合、最大値に設定
    else if (floatValue > max) {
      inputWidthElement.value = String(max);
    }
  }

  /**
   * 高さ入力チェック
   */
  private inputHeightCheck = () => {
    const min = 10
    const max = 1000;

    const inputHeightElement = <HTMLInputElement>document.getElementById('autoBeamHeight');
    const floatValue = parseFloat(inputHeightElement.value);
    if (floatValue === null || Number.isNaN(floatValue)) {
      inputHeightElement.value = String(min);
    }
    // 値が最小値未満の場合、最小値に設定
    if (floatValue < min) {
      inputHeightElement.value = String(min);
    }
    // 値が最大値を超える場合、最大値に設定
    else if (floatValue > max) {
      inputHeightElement.value = String(max);
    }
  }

  /**
   * 梁サイズの設定/オフセット算出
   */
  private onBtnSizeSetClicked = (e) => {   
    document.getElementById('warningMsg').innerHTML = '';
    let value: number;
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      const input = <HTMLInputElement>document.getElementById('autoBeamWidth');
      value = Number(input.value);
    } else {
      const select = <HTMLSelectElement>document.getElementById("divisionList");
      value = Number(select.value) * marietta.webcad.WebCADGlobal.webcad2Dmanager.modulePitch;
    }

    this.reCreateView(value);
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();

    if (this.itemList.length === this.currentIndex) {
      this.finish();
      return;
    }

    this.next();
  }

  /**
   * 再描画
   * @param value 
   */
  private reCreateView(value: number) {
    // shape(dotlist) 反時計回りに作成している かつ shape[1], shape[2] が外周と一致
    const dotList = this.target.itemInfo.dotList;
    const convertPixToMM = marietta.webcad.util.WebCADUtil.convertPixToMM;
    const p1 = new THREE.Vector2(convertPixToMM(dotList[0].x), convertPixToMM(dotList[0].y));
    const p2 = new THREE.Vector2(convertPixToMM(dotList[1].x), convertPixToMM(dotList[1].y));
    const p4 = new THREE.Vector2(convertPixToMM(dotList[3].x), convertPixToMM(dotList[3].y));
    
    const dir = p1.clone().sub(p2);
    const normalize = dir.clone().normalize();
    const offset = normalize.multiplyScalar(value).sub(dir);

    const p1_ = p1.clone().add(offset);
    const p4_ = p4.clone().add(offset);

    const convertMMToPix = marietta.webcad.util.WebCADUtil.convertMMToPix;
    this.target.itemInfo.dotList = [
      new marietta.webcad.collection.PointCollection(convertMMToPix(p1_.x), convertMMToPix(p1_.y)),
      this.target.itemInfo.dotList[1],
      this.target.itemInfo.dotList[2],
      new marietta.webcad.collection.PointCollection(convertMMToPix(p4_.x), convertMMToPix(p4_.y)),
    ];
    this.target.itemInfo.height = parseFloat((<HTMLInputElement>document.getElementById('autoBeamHeight')).value);

    this.target.reCreateImage();
  }

  /**
   * 作成しないボタンが押された
   * @param e 
   */
  private onBtnCancelClicked = (e) => {
    e.preventDefault();

    this.target.deleteMe();
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();

    if (this.itemList.length === this.currentIndex) {
      this.finish();
      return;
    }

    this.next();
  }

  public close = () => {
    this.removeEvevntInputCheck();
    // モーダルの削除
    $("#modalBgForRoomSelect").hide();  
  
    // 見積一覧更新
    marietta.webcad.WebCADGlobal.quotationItemList.createData(true);

    this.closeEvent();
  }

  /**
   * override
   */
  public closeEvent() {
    super.closeEvent();
  }

  /**
   * デフォルト値をセット
   */
  private setDefault = () => {
    (<HTMLInputElement>document.getElementById('autoBeamHeight')).value = '500';
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      (<HTMLInputElement>document.getElementById('autoBeamWidth')).value = '350';
    } else {
      (<HTMLSelectElement>document.getElementById("divisionList")).selectedIndex = 1; // 1/4
    }
  }

  private next = () => {
    this.setDefault();
    this.target = this.itemList[this.currentIndex] as marietta.webcad.item.Beam;
    marietta.webcad.WebCADGlobal.itemManager.currentItem = this.target;
    this.scrollPosition(this.itemList[this.currentIndex]); // 画面位置調節
    this.reposition(this.itemList[this.currentIndex]); // ダイアログと青線位置調節
    this.beamSelect(this.itemList[this.currentIndex]); // 青枠・モーダル
    this.currentIndex += 1;
  }

  /**
   * 次に選択する梁が存在しない
   */
  private finish() {
    marietta.WebCADGlobal.itemManager.currentItem = null;
    this.removeEvevntInputCheck();

    // パネルを閉じる
    marietta.webcad.WebCADGlobal.removeDialog();
    // 青枠・モーダルの削除
    $("#modalBgForRoomSelect").hide();
  }

  /**
   * 画面の位置調節
   */
  private scrollPosition(beam: marietta.webcad.item.Beam): void {

    //部屋のバウンド
    const _bound = beam.viewObj.getBoundingClientRect();
    const bound: marietta.core.Rectangle = new marietta.core.Rectangle(_bound.left - 5, _bound.top - 5, _bound.width + 10, _bound.height + 10);

    //scroll the screen if object not in the visible screen
    const view2D: HTMLElement = document.getElementById("webcad2dViewInner");
    const currentScrollPosition: marietta.core.Point = new marietta.core.Point(view2D.scrollLeft, view2D.scrollTop);
    let { top, left, bottom, right } = view2D.getBoundingClientRect();
    let scrollBarWidth = view2D.offsetWidth - view2D.clientWidth;
    right = right - left - scrollBarWidth;
    bottom = bottom - top - scrollBarWidth;
    const margin = 100;
    let xDiff = 0, yDiff = 0;
    if (bound.x < left) xDiff = bound.x - left - margin - bound.width;
    if (bound.y < top) yDiff = bound.y - top - margin - bound.height;

    if (bound.x > right) xDiff = bound.x - right + margin + bound.width;
    if (bound.y > bottom) yDiff = bound.y - bottom + margin + bound.height;

    marietta.webcad.WebCADGlobal.scrollerManager.setScrollPosition(currentScrollPosition.x + xDiff, currentScrollPosition.y + yDiff);

}

  /**
   * 青枠・モーダル
   */
  private beamSelect(beam: marietta.webcad.item.Beam): void {
    
      //異なる階の場合は、階を変更する
      const targetFloor: number = beam.itemInfo.floor;
      if (targetFloor != marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor) {
          marietta.webcad.WebCADGlobal.changeFloor(targetFloor);
      }
      
      const _bound = this.target.viewObj.getBoundingClientRect();
      let bound: marietta.core.Rectangle = new marietta.core.Rectangle(_bound.left - 5, _bound.top - 5, _bound.width + 10, _bound.height + 10);

      //グレイを作る
      const path: string = "M0, 0" +
          "L" + window.innerWidth + ", 0" +
          "L" + window.innerWidth + "," + window.innerHeight +
          "L" + (bound.x + bound.width) + "," + window.innerHeight +
          "L" + (bound.x + bound.width) + "," + (bound.y + bound.height) +
          "L" + (bound.x + bound.width) + "," + bound.y +
          "L" + bound.x + "," + bound.y +
          "L" + bound.x + "," + (bound.y + bound.height) +
          "L" + (bound.x + bound.width) + "," + (bound.y + bound.height) +
          "L" + (bound.x + bound.width) + "," + window.innerHeight +
          "L 0," + window.innerHeight +
          "L 0, 0Z";
      document.getElementById("modalBgForRoomSelect_fill")?.setAttribute("d", path);

      $("#modalBgForRoomSelect").show();
      $("#modalBg").hide();

    }
  
  /**
   * ダイアログの位置調節
   */
  private reposition(target: marietta.webcad.item.Beam): void {
    //ダイアログの位置            
    //部屋が右半分のところにある
    const _bound = target.viewObj.getBoundingClientRect();
    let bound: marietta.core.Rectangle = new marietta.core.Rectangle(_bound.left - 5, _bound.top - 5, _bound.width + 10, _bound.height + 10);

    const mybound = document.getElementById('WizardBeamSizeSettingDialog').getBoundingClientRect();
    let posX: number = 0;
    let posY: number = 0;

    // 上下左右の差分
    const top = bound.y;
    const bottom = window.innerHeight - (bound.y + bound.height);
    const right = window.innerWidth - (bound.x + bound.width);
    const left = bound.x;
   
    // 位置計算
    if (top > bottom && top > right && top > left) {
      posX = 0;
      posY = - top / 2 + mybound.height;
    } else if (bottom > top && bottom > right && bottom > left) {
      posX = 0;
      posY = top / 2;
    } else if (right > top && right > bottom && right > left) {
      posX = left / 2;
      posY = 0;
    } else if (left > top && left > bottom && left > right) {
      posX = - left / 2 + mybound.width;
      posY = 0;          
    } 

    // 画面いっぱいに表示されている場合は中央にする
    if (bound.height > top && bound.height > bottom && bound.width > left && bound.width > right) {
      posX = 0;
      posY = 0;
    }

    // 画面外のケースは中央にする
    if (posX < - window.innerWidth / 2 || window.innerWidth / 2 < posX 
    || posY < - window.innerHeight / 2 || window.innerHeight / 2 < posY) {
      posX = 0;
      posY = 0;
    }

    this.dialogPosition.x = posX;
    this.dialogPosition.y = posY;

    const cssTransform = 'translate(' + posX + 'px,' + posY + 'px)';
    $(this.viewObj).css({ transform: cssTransform });

  }

}